import React, { useState, useEffect, useMemo } from "react";
import { Link, useNavigate, useLocation, NavLink } from 'react-router-dom';
import { Col, Row, Card, Container, Breadcrumb, Nav, Tab } from "react-bootstrap";
import { TabView, TabPanel } from 'primereact/tabview';

import { LiaUserEditSolid, LiaLuggageCartSolid } from "react-icons/lia";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { PiInvoiceFill } from "react-icons/pi";

import Client_accountdelails from '../../components/clientpart/Client_accountdelails';
import Client_services from '../../components/clientpart/Client_services';
import Payment_status from '../../components/clientpart/Payment_status';
import Client_invoicelist from '../../components/clientpart/Client_invoicelist';
import axios from 'axios';
import config from '../../config';

import { useClientAuth } from '../../context/ClientAuthContext';

import GifLoder from '../../components/GifLoder';
import Old_CilentInvoices from "../../components/clientpart/Old_CilentInvoices";
import OnboardingTour from '../../components/onboarding/OnboardingTour';
import getClientProfileOnboardingSteps from '../../components/onboarding/clientProfileOnboardingSteps';
import { ONBOARDING_CHAIN_PHASE, handleOnboardingChainFinish } from '../../components/onboarding/onboardingStorage';

const Client_profile = () => {

  const { isAuthenticated, role, logout, username, ClientId, accessToken, apiRequest } = useClientAuth();
  const navigate = useNavigate();
  const [clientDetails, setClientDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showOldInvoices, setShowOldInvoices] = useState(false);
  // Controlled so the onboarding tour can switch tabs (e.g. to open "My Services"/
  // "Invoices" before spotlighting them) - see clientProfileOnboardingSteps.js.
  const [activeTabKey, setActiveTabKey] = useState('first');

  // `setActiveTabKey` is a stable state setter, so this only needs to be built once -
  // keeps the same steps array (and thus the same onEnter/onExit closures) across
  // re-renders instead of recreating it (and re-triggering the tour's target-locate
  // effect) every time this page re-renders.
  const profileOnboardingSteps = useMemo(() => getClientProfileOnboardingSteps(setActiveTabKey), []);

  const handleProfileTourFinish = (status) => {
    const nextPath = handleOnboardingChainFinish(ONBOARDING_CHAIN_PHASE.PROFILE, status);
    if (nextPath) navigate(nextPath);
  };

  useEffect(() => {
    const fetchClientDetails = async () => {
      setLoading(true);
      try {
        const response = await apiRequest(
          `${config.apiBASEURL}/ClientRoutes/specific-client/${ClientId}`
        );
        setClientDetails(response.data);
      } catch (err) {
        console.error('Error fetching client details:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchClientDetails();
  }, [ClientId, apiRequest]);


// Check old invoice status
useEffect(() => {
  const checkInvoiceStatus = async () => {
      try {
          const res = await apiRequest(`${config.apiBASEURL}/OldInvoiceRoutes/check-invoice-status`, {
              params: { client_id: ClientId }
          });

          if (res.data.success) {
              setShowOldInvoices(true);
          } else {
              setShowOldInvoices(false);
          }
      } catch (err) {
          console.error('Error checking invoice status:', err);
          setShowOldInvoices(false);
      }
  };

  if (ClientId) {
      checkInvoiceStatus();
  }
}, [ClientId, apiRequest]);



  if (loading) {
    return <div className="loderDiv">
      <GifLoder />
    </div>;
  }



  return (
    <>
      <OnboardingTour steps={profileOnboardingSteps} namespace="client-profile" onFinish={handleProfileTourFinish} />
      <Container fluid className="mainc_body">
        <div className="serviceclient2">
          <Row className="mx-0">
            <Col md={6} lg={6} className="mb-4 offset-lg-0 offset-xxl-1">
              <Breadcrumb data-onboarding="client-profile-header">
                <Breadcrumb.Item active>
                  <img
                    src={require("../../assets/images/client-default.png")}
                    alt="User"
                    style={{ width: '32px', height: '32px', marginRight: '10px' }}
                  />
                  Hello, {username}
                </Breadcrumb.Item>
              </Breadcrumb>
            </Col>
          </Row>
          <Row>
            <Tab.Container id="left-tabs-example" activeKey={activeTabKey} onSelect={(key) => setActiveTabKey(key || 'first')}>
              <Row>
                <Col className="cli_Profiledata">
                  <Card className="sticky-top p-2 pe-0 h-auto" style={{ top: '100px' }}>
                    <Nav variant="pills" className="flex-column">
                      <Nav.Item>
                        <Nav.Link eventKey="first"><i><LiaUserEditSolid /></i>  My Profile</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second"><i><LiaLuggageCartSolid /></i> My Services</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="forth"><i><PiInvoiceFill /></i> Invoices</Nav.Link>
                      </Nav.Item>
                      {showOldInvoices && (
                        <Nav.Item>
                          <Nav.Link eventKey="old"><i><PiInvoiceFill /></i> Old Invoices</Nav.Link>
                        </Nav.Item>
                      )}
                      {/* <Nav.Item>
                                <Nav.Link eventKey="therd"><i><MdOutlineAccountBalanceWallet /></i> Payment Status</Nav.Link>
                              </Nav.Item> */}
                    </Nav>
                  </Card>
                </Col>
                <Col sm={9} className="ct_proleftdet">
                  <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <Card style={{ overflow: 'hidden' }}>
                        <Card.Body className="fadeInRight">
                          <Client_accountdelails clientDetails={clientDetails} onUpdateClientDetails={setClientDetails} />
                        </Card.Body>
                      </Card>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <Card style={{ overflow: 'hidden' }} data-onboarding="client-profile-services-panel">
                        <Card.Body className="fadeInRight">
                          <Client_services />
                        </Card.Body>
                      </Card>
                    </Tab.Pane>
                    <Tab.Pane eventKey="forth">
                      <Card style={{ overflow: 'hidden' }} data-onboarding="client-profile-invoices-panel">
                        <Card.Body className="fadeInRight">
                          <Client_invoicelist />
                        </Card.Body>
                      </Card>
                    </Tab.Pane>
                    {showOldInvoices && (
                      <Tab.Pane eventKey="old">
                        <Card style={{ overflow: 'hidden' }}>
                          <Card.Body className="fadeInRight">
                            <Old_CilentInvoices />
                          </Card.Body>
                        </Card>
                      </Tab.Pane>
                    )}
                    {/* <Tab.Pane eventKey="therd">
                              <Card style={{overflow: 'hidden'}}>
                                  <Card.Body className="fadeInRight">
                                      <Payment_status />
                                  </Card.Body>
                              </Card>
                            </Tab.Pane> */}
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </Row>
        </div>
      </Container>
    </>
  );
}

export default Client_profile;
